module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-7-df3c9456.png";